export default "__VITE_ASSET__DNfeHM0S__"